export function isValidBucket(bucket: string): boolean {
  return /^[a-zA-Z0-9.\-_]{1,255}$/.test(bucket);
}

export function isValidRoleArn(arn: string): boolean {
  return /^arn:aws:iam::\d{12}:role\/.+$/.test(arn);
}

export const BUCKET_ERROR =
  'The S3 bucket name does not comply with AWS naming rules. See https://docs.aws.amazon.com/AmazonS3/latest/userguide/bucketnamingrules.html.';

export const ROLE_ARN_ERROR =
  'The Role ARN must be a valid AWS IAM role ARN (e.g., arn:aws:iam::123456789012:role/BenchlingConnectS3Access).';
